import * as tslib_1 from "tslib";
import { BufferConfig } from '../components/buffer/buffer.config';
import { ESRI } from '../esri-loader-util';
import { AreaUnits } from '../selectionOptions';
import { LayerService } from './layer.service';
import * as i0 from "@angular/core";
import * as i1 from "./layer.service";
var BufferService = /** @class */ (function () {
    function BufferService(layerService) {
        this.layerService = layerService;
        this.bufferFeatureLimit = 2000;
        this.numberAreaDecimals = 5;
        this.bufferConfig = new BufferConfig();
    }
    BufferService.prototype.getDefaultBufferOptions = function () {
        return this.bufferConfig.defaultBufferOptions;
    };
    /**
     * Create geodesic buffer polygons client-side around the input layer's geometries.
     * Multiple buffers are returned for each layer if multiple distance values are provided.
     */
    BufferService.prototype.getLayerBuffers = function (layers, bufferOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, results, layers_1, layers_1_1, layer, g, geometries, buffers, buffers_1, buffers_1_1, buffer, e_1_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        results = null;
                        if (!layers) return [3 /*break*/, 10];
                        results = [];
                        layers = Array.isArray(layers) ? layers : [layers];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 8, 9, 10]);
                        layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next();
                        _c.label = 2;
                    case 2:
                        if (!!layers_1_1.done) return [3 /*break*/, 7];
                        layer = layers_1_1.value;
                        return [4 /*yield*/, this.layerService.getLayerGeometry(layer, this.bufferFeatureLimit + 1)];
                    case 3:
                        g = _c.sent();
                        geometries = Array.isArray(g) ? g : [g];
                        buffers = [];
                        if (!(geometries.length <= this.bufferFeatureLimit)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getGeometryBuffers(geometries, bufferOptions)];
                    case 4:
                        buffers = _c.sent();
                        try {
                            for (buffers_1 = tslib_1.__values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
                                buffer = buffers_1_1.value;
                                buffer.layer = layer;
                                buffer.title = this.getBufferTitle(buffer);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (buffers_1_1 && !buffers_1_1.done && (_b = buffers_1.return)) _b.call(buffers_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        _c.label = 5;
                    case 5:
                        results.push({
                            layerId: layer.id,
                            featureCount: geometries.length,
                            buffers: buffers
                        });
                        _c.label = 6;
                    case 6:
                        layers_1_1 = layers_1.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _c.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/, results];
                }
            });
        });
    };
    /**
     * Create geodesic buffer polygons client-side around the input geometries.
     * Multiple buffers are returned for each layer if multiple distance values are provided.
     */
    BufferService.prototype.getGeometryBuffers = function (geometry, bufferOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_3, _a, e_4, _b, Graphic, buffers, symbol, distances, distances_1, distances_1_1, distance, result, polygons, polygons_1, polygons_1_1, polygon, graphic, buffer, _c, e_4_1, e_3_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, ESRI.Graphic];
                    case 1:
                        Graphic = _d.sent();
                        buffers = [];
                        return [4 /*yield*/, this.getSymbolProperties(bufferOptions)];
                    case 2:
                        symbol = _d.sent();
                        distances = Array.isArray(bufferOptions.distance) ? bufferOptions.distance : [bufferOptions.distance];
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 16, 17, 18]);
                        distances_1 = tslib_1.__values(distances), distances_1_1 = distances_1.next();
                        _d.label = 4;
                    case 4:
                        if (!!distances_1_1.done) return [3 /*break*/, 15];
                        distance = distances_1_1.value;
                        return [4 /*yield*/, this.applyBuffer(geometry, bufferOptions, distance)];
                    case 5:
                        result = _d.sent();
                        polygons = Array.isArray(result) ? result : [result];
                        _d.label = 6;
                    case 6:
                        _d.trys.push([6, 12, 13, 14]);
                        polygons_1 = tslib_1.__values(polygons), polygons_1_1 = polygons_1.next();
                        _d.label = 7;
                    case 7:
                        if (!!polygons_1_1.done) return [3 /*break*/, 11];
                        polygon = polygons_1_1.value;
                        graphic = new Graphic({ symbol: symbol, geometry: polygon });
                        buffer = { title: '', distance: distance, distanceUnit: bufferOptions.distanceUnit, graphic: graphic };
                        buffer.title = this.getBufferTitle(buffer);
                        if (!bufferOptions.areaUnit) return [3 /*break*/, 9];
                        buffer.areaUnit = bufferOptions.areaUnit;
                        _c = buffer;
                        return [4 /*yield*/, this.calculateArea(polygon, bufferOptions.areaUnit)];
                    case 8:
                        _c.area = _d.sent();
                        _d.label = 9;
                    case 9:
                        buffers.push(buffer);
                        _d.label = 10;
                    case 10:
                        polygons_1_1 = polygons_1.next();
                        return [3 /*break*/, 7];
                    case 11: return [3 /*break*/, 14];
                    case 12:
                        e_4_1 = _d.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 14];
                    case 13:
                        try {
                            if (polygons_1_1 && !polygons_1_1.done && (_b = polygons_1.return)) _b.call(polygons_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 14:
                        distances_1_1 = distances_1.next();
                        return [3 /*break*/, 4];
                    case 15: return [3 /*break*/, 18];
                    case 16:
                        e_3_1 = _d.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 18];
                    case 17:
                        try {
                            if (distances_1_1 && !distances_1_1.done && (_a = distances_1.return)) _a.call(distances_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 18: return [2 /*return*/, buffers];
                }
            });
        });
    };
    BufferService.prototype.applyBuffer = function (geometry, bufferOptions, distance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var geometryEngine;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.GeometryEngineAsync];
                    case 1:
                        geometryEngine = _a.sent();
                        return [2 /*return*/, geometryEngine.geodesicBuffer(geometry, distance, bufferOptions.distanceUnit, bufferOptions.unionResults)];
                }
            });
        });
    };
    BufferService.prototype.calculateArea = function (geometry, unit) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var geometryEngine;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.GeometryEngineAsync];
                    case 1:
                        geometryEngine = _a.sent();
                        return [2 /*return*/, geometryEngine.geodesicArea(geometry, unit)];
                }
            });
        });
    };
    BufferService.prototype.getSymbolProperties = function (bufferOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Color, color, outlineColor;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ESRI.loadModules('esri/Color')];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), Color = _a[0];
                        color = new Color(bufferOptions.fillColor);
                        if (color.a < 1) {
                            bufferOptions.opacity = 1;
                        }
                        outlineColor = new Color(bufferOptions.outlineColor);
                        return [2 /*return*/, {
                                type: 'simple-fill',
                                color: color,
                                style: bufferOptions.fillType,
                                outline: {
                                    color: outlineColor,
                                    style: bufferOptions.outlineType,
                                    width: bufferOptions.lineWidth
                                }
                            }];
                }
            });
        });
    };
    BufferService.prototype.getBufferTitle = function (buffer) {
        var title = 'Geometry';
        if (buffer.layer) {
            if (buffer.layer.mapcoreProps && buffer.layer.mapcoreProps.name) {
                title = buffer.layer.mapcoreProps.name;
            }
            else if (buffer.layer.graphics) {
                title = buffer.layer[0].geometry.type;
            }
        }
        title += " - Buffer (" + buffer.distance + " " + buffer.distanceUnit + ")";
        if (buffer.area) {
            var unit = AreaUnits.find(function (u) { return u.value === buffer.areaUnit; });
            title += " (" + buffer.area.toFixed(this.numberAreaDecimals) + " " + unit.name + ")";
        }
        return title[0].toUpperCase() + title.slice(1);
    };
    BufferService.prototype.addBufferToMap = function (buffers, bufferOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_5, _a, graphicsLayers, buffers_2, buffers_2_1, buffer, graphicsLayer, e_5_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        graphicsLayers = [];
                        buffers = Array.isArray(buffers) ? buffers : [buffers];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        buffers_2 = tslib_1.__values(buffers), buffers_2_1 = buffers_2.next();
                        _b.label = 2;
                    case 2:
                        if (!!buffers_2_1.done) return [3 /*break*/, 5];
                        buffer = buffers_2_1.value;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: buffer.title, graphicLayer: 'polygon', opacity: bufferOptions.opacity })];
                    case 3:
                        graphicsLayer = _b.sent();
                        graphicsLayer.add(buffer.graphic);
                        graphicsLayers.push(graphicsLayer);
                        _b.label = 4;
                    case 4:
                        buffers_2_1 = buffers_2.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_5_1 = _b.sent();
                        e_5 = { error: e_5_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
                        }
                        finally { if (e_5) throw e_5.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        bufferOptions.opacity = this.getDefaultBufferOptions().opacity;
                        return [2 /*return*/, graphicsLayers];
                }
            });
        });
    };
    BufferService.ngInjectableDef = i0.defineInjectable({ factory: function BufferService_Factory() { return new BufferService(i0.inject(i1.LayerService)); }, token: BufferService, providedIn: "root" });
    return BufferService;
}());
export { BufferService };
